















































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import ConfigIntegradorFinxStore from '@/components/Configuracoes/store/ConfigIntegradorFinxStore'

@Component

export default class ViewConfiguracaoIntegrador extends Vue {
  loadConfiguracao: string = ''
  loadClientes: boolean = false
  loadTable: boolean = false
  modalIntegrador: boolean = false

  get pagination() {
    return this.getConfigIntegradorFinxStore.pagination
  }

  get getConfigIntegradorFinxStore() {
    return getModule(ConfigIntegradorFinxStore, this.$store)
  }

  get loadingTable() {
    return this.loadTable
  }

  set loadingTable(value: boolean) {
    this.loadTable = value
  }

  get loadingConfiguracoes() {
    return this.loadConfiguracao
  }

  set loadingConfiguracoes(value: string) {
    this.loadConfiguracao = value
  }

  get loadingClientes() {
    return this.loadClientes
  }

  set loadingClientes(value: boolean) {
    this.loadClientes = value
  }

  get getClienteId() {
    return this.getConfigIntegradorFinxStore.clienteId
  }

  set getClienteId(value: any) {
    this.getConfigIntegradorFinxStore.setClienteId(value)
  }

  get getClientes() {
    return this.getConfigIntegradorFinxStore.clientes
  }

  get integradorHeaders() {
    return [
      { text: 'Integração', value: 'Key', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get getIntegracoes() {
    return this.getConfigIntegradorFinxStore.integracoes
  }

  async clienteChange(clienteKey: any) {
    this.loadingTable = true
    await this.getConfigIntegradorFinxStore.getIntegracoesByClienteKey(clienteKey)
    this.loadingTable = false
  }


  addIntegrador(item: any) { }
  item: any = {}
  async openIntegrador(item: any) {
    this.modalIntegrador = true
    this.item = item
  }

  get getYaml() {
    return JSON.stringify(this.item)
  }

  closeModalIntegrador() {
    this.modalIntegrador = false
  }

  async mounted() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    // @ts-ignore
    await this.getConfigIntegradorFinxStore.getAllClientes()
    EventBus.$emit('clearLoadingRequest')
  }
}
